import styled from 'styled-components';

const Wrapper = styled.div`
  width: 100vw;
  height: 100%;
  /* max-width: 90%; */
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 50px;
`;

const Header = styled.div`
  background: #05d6e1;
  height: 140px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const HeaderTitle = styled.h1`
  font-size: 24px;
  color: #fff;
  margin-bottom: 10px;
`;

const HeaderDescription = styled.p`
  font-size: 14px;
  color: #fff;
`;

const Section = styled.div`
  width: 100%;
  padding: 30px;
  background: #fff;
`;

const Title = styled.h1`
  font-size: 20px;
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 2px solid #1a1a1a;
`;

const Content = styled.div`

`;

const Item = styled.div`
  margin-top: 10px;
  margin-bottom: 15px;
  height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  position: relative;

  p {
    font-size: 14px;
    font-weight: 700;
    color: #1a1a1a;
    margin-bottom: 8px;
    width: 190px;
    padding-left: 20px;

    @media only screen and (max-width: 767px) {
      padding-left: 0px;
    }
  }

  input {
    width: 350px;
    outline: 0;
    height: 42px;
    padding: 8px 15px;
    min-width: 120px;
    border-radius: 4px;
    border: 1px solid #dcdcdc;
    font-size: 14px;
    font-weight: 400;
    -webkit-appearance: none;

    &::-webkit-outer-spin-button, &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }

  span {
    font-size: 14px;
    font-weight: 400;
  }
`;

const Required = styled.span`
  position: absolute;
  font-size: 30px !important;
  font-weight: bold;
  color: #e95950;
  top: 6px;
  left: 2px;
`;

const Button = styled.button`
  width: 250px;
  height: 50px;
  border: 0 none;
  background-color: #05d6e1;
  color: #fff;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 0.5px;
  cursor: pointer;
`;

const ShopItem = styled.div`
  width: 100%;
`;

const ShopItemHeader = styled.div`
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid #ddd;

  > div {
    padding: 0 20px 20px 20px;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: -0.3px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  @media only screen and (max-width: 767px) {
    > div:last-child {
      display: none;
    }
  }
`;

const ShopItemCell = styled.div`
  font-size: 14px;
  color: #4c4c4c;
  letter-spacing: -0.3px;
  font-weight: 400;

  &:first-child {
    flex: 3;
  }
  &:last-child {
    flex: 1;
  }

  @media only screen and (max-width: 767px) {
    &:first-child {
      flex: 2;
    }
    &:last-child {
      flex: 1;
    }
  }
`;

const ShopItemBody = styled.div`
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid #ddd;

  > div {
    padding: 20px;
    word-break: break-all;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;

    &:last-child {
      align-items: center;
    }
  }
`;

const SectionContent = styled.div`
  display: flex;
  flex-direction: column;
`;

const Radio = styled.label`
  position: relative;
  padding-left: 30px;
  font-size: 14px;

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    width: 0;
    height: 0;

    ~ span {
      background-color: #ccc;
    }

    &:checked {
      ~ span {
        background-color: #05d6e1;
        &:after {
          display: block;
        }
      }
    }
  }

  span {
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    width: 20px;
    background-color: #eee;
    border-radius: 50%;

    &:after {
      content : "";
      position: absolute;
      display: none;
      top: 6px;
      left: 6px;
      width: 9px;
      height: 9px;
      border-radius: 50%;
      background: #fff;
    }
  }
`;

export {
  Wrapper,
  Header,
  HeaderTitle,
  HeaderDescription,
  Section,
  Title,
  Content,
  Item,
  Button,
  ShopItem,
  ShopItemHeader,
  ShopItemCell,
  ShopItemBody,
  SectionContent,
  Radio,
  Required,
};
